export const REAL_DATA_LOCALE_STORAGE_KEY = 'real_data-collapsed'
